const ActiveCountries  = ['AE', 'KW', 'SA', 'OM', 'BH', 'QA', 'UK', 'GB']

export default ActiveCountries;